import { IMaterialCallout, MaterialCallout } from './material-callout';

export interface ILaborCallout {
    standardLaborId: string | undefined;
    id: string;
    description: string;
    customerSummary: string;
    time: number;
    materials: IMaterialCallout[];
}


export class LaborCallout implements ILaborCallout {
    public standardLaborId: string | undefined = undefined;
    public id: string = '';
    public description: string = '';
    public customerSummary: string = '';
    public time: number = 0;
    public materials: IMaterialCallout[] = [];
}


